import { X } from 'lucide-react'
import { clsx } from 'clsx'

interface ChatReplyPreviewProps {
  userName: string
  text: string
  imageUrl?: string
  onCancel?: () => void
  onNavigate?: () => void
}

export function ChatReplyPreview({
  userName,
  text,
  imageUrl,
  onCancel,
  onNavigate,
}: ChatReplyPreviewProps) {
  // Input bar mode: onCancel is present
  // Bubble mode: no onCancel, onNavigate for click-to-original
  const isInputMode = !!onCancel

  return (
    <div
      className={clsx(
        'border-l-2 border-primary-400 pl-2',
        isInputMode ? 'py-1.5 flex items-start gap-2' : 'py-1 mb-1.5',
        !isInputMode && onNavigate && 'cursor-pointer active:opacity-70'
      )}
      onClick={!isInputMode && onNavigate ? (e: React.MouseEvent) => { e.stopPropagation(); onNavigate() } : undefined}
    >
      <div className="flex-1 min-w-0">
        <span
          className={clsx(
            'font-medium text-primary-500',
            isInputMode ? 'text-xs' : 'text-meta'
          )}
        >
          {userName}
        </span>
        <p
          className={clsx(
            'text-caption truncate',
            isInputMode ? 'text-xs' : 'text-meta'
          )}
        >
          {text || (imageUrl ? '사진' : '')}
        </p>
      </div>

      {isInputMode && (
        <button
          onClick={onCancel}
          className="flex-shrink-0 p-0.5 rounded text-caption hover:text-heading transition-colors"
          aria-label="답장 취소"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  )
}
